export default {
  getCollections: (state: any) => state.collections,
  getNotificationList: (state: any) => state.notifications.map((el: any, idx: number) => ({...el, idx: idx + 1})),
};
